import * as AK from '@ariakit/react'
import * as S from './styles'

export interface LabelProps extends AK.FormLabelProps {}

export const Label = (props: LabelProps) => (
  // This is opposite of our usual
  // <AK.FormLabel render={<S.Label />} />
  // because AK.FormLabel can render as label or span depending on the kind of
  // input. See https://ariakit.org/reference/form-label
  <S.Label as={AK.FormLabel} {...props} />
)
